import { CardActionArea, Paper, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import React from 'react';
import useTheme from '@material-ui/core/styles/useTheme';

interface StaffSlotProps {
  name: string;
  onClick?: () => void;
}

const StaffSlot = ({ name, onClick }: StaffSlotProps) => {
  const theme = useTheme();

  return (
    <Paper
      variant="outlined"
      style={{ flex: 1, display: 'flex', alignItems: 'stretch', cursor: 'pointer' }}
      onClick={onClick}
    >
      <CardActionArea
        onClick={onClick}
        style={{ flex: 1, display: 'flex', padding: theme.spacing(2), gap: theme.spacing(2) }}
      >
        <Box flex={1} display="flex" flexDirection="column">
          <Typography>{name ?? '-'}</Typography>
        </Box>
      </CardActionArea>
    </Paper>
  );
};

export default StaffSlot;
